import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/auth';
import headerProps from './reducers/headerProps';

export const store = configureStore({
    reducer: {
        authReducer,
        headerProps
    },
})